import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink, Trophy, ArrowRight } from 'lucide-react';
import { trackFindClubEvent } from '@/utils/analytics';

const FUTWORK_REGISTRATION_URL = 'https://futwork.io/register/player/futwork-soccer-academy-players-4c66a629';

export function FutWorkCTA() {
  const handleCTAClick = () => {
    trackFindClubEvent('futwork_cta_clicked', { source: 'find_club_page' });
    window.open(FUTWORK_REGISTRATION_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="p-5 md:p-6 bg-gradient-to-br from-primary/5 via-primary/10 to-secondary/5 border border-border/50 rounded-xl md:rounded-2xl">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-2 mb-1.5">
            <div className="w-7 h-7 md:w-8 md:h-8 rounded-lg bg-primary/10 flex items-center justify-center">
              <Trophy className="w-3.5 h-3.5 md:w-4 md:h-4 text-primary" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-foreground">
              Don't have a club?
            </h3>
          </div>
          <p className="text-sm text-muted-foreground">
            Join FutWork Soccer Academy and start your journey
          </p>
        </div>
        <Button 
          onClick={handleCTAClick}
          className="w-full md:w-auto bg-gradient-to-r from-amber-400 to-orange-500 text-foreground hover:from-amber-500 hover:to-orange-600 rounded-full px-6 h-11 md:h-12 text-sm font-semibold shadow-lg shadow-amber-500/20 active:scale-[0.98]"
        >
          Join FutWork Academy
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
